import { createAdapterToConceptGroup } from "../../conceptGroups/adapters/conceptGroup.adapter";
import { Concept, ConceptEndpoint } from "../domain/Concept.model";

type Dictionary = {
    [key: string]: string;
};

const conceptAttributesDiccionary: Dictionary = {
    id: 'ConceptoID',
    name: 'Concepto',
    conceptGroupId: 'GrupoConceptoID',
    order :'Orden',
}

export const createAdapterToFieldConceptEndpoint = (key: string): string => {
    return conceptAttributesDiccionary[key];
}

export const createAdapterToConceptEndpoint = (concept: Concept) => {
    const formattedConcept: Partial<ConceptEndpoint> = {
        ConceptoID: concept.id ?? undefined,
        Concepto: concept.name,
        GrupoConceptoID: concept.conceptGroupId,
        Orden: concept.order,
    };
    return formattedConcept;
}

export const createAdapterToConcept = (conceptEndpoint: ConceptEndpoint) => {
    const formattedConcept: Concept = {
        id: conceptEndpoint.ConceptoID,
        name: conceptEndpoint.Concepto,
        conceptGroupId: conceptEndpoint.GrupoConceptoID,
        conceptGroup: conceptEndpoint.GrupoConcepto? createAdapterToConceptGroup(conceptEndpoint.GrupoConcepto) : undefined,
        order: conceptEndpoint.Orden,
    };
    return formattedConcept;
}